import { relationships } from "@rocicorp/zero";
import { file } from "./file";
import { fileClassification } from "./file-classification";

export const fileClassificationRelationships = relationships(fileClassification, ({ one }) => ({
	file: one({
		sourceField: ["fileId"],
		destField: ["id"],
		destSchema: file,
	}),
}));
